import { AlertDialogState } from "../../reducers/components/AlertDialogReducer";

export type AlertDialogAction =
  | {
      type: "DISPLAY_ALERT_DIALOG";
      payload: AlertDialogState;
    }
  | {
      type: "CLOSE_ALERT_DIALOG";
      payload: [];
    };

function openAlertDialog(
  title: string,
  message: string,
  btnOnetext: string,
  btnOneOnclick: any,
  btnTwotext: string,
  btnTwoOnclick: any,
  btnOneColor: string = "",
  btnTwoColor: string = ""
): AlertDialogAction {
  return {
    type: "DISPLAY_ALERT_DIALOG",
    payload: {
      title: title,
      message: message ,
      btnOnetext: btnOnetext,
      btnOneOnclick: btnOneOnclick,
      btnOneColor: btnOneColor,
      btnTwotext: btnTwotext,
      btnTwoOnclick: btnTwoOnclick,
      btnTwoColor: btnTwoColor,
      open: false
    },
  };
}

function closeAlertDialog(): AlertDialogAction {
  return { type: "CLOSE_ALERT_DIALOG", payload: [] };
}

export const AlertDialogActions = {
  openAlertDialog,
  closeAlertDialog,
};
